function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 0h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2zM0 4h2v14h14v2H2c-1.1 0-2-.9-2-2V4zm6 10V2h12v12H6zm10-7H8v2h8V7zm-8 3h4v2H8v-2zm8-6H8v2h8V4z",
  fill: "#000",
  fillOpacity: 0.54
});

var SvgIconLibraryBooks = function SvgIconLibraryBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/icon-library_books.f94c43a9.svg";
export { SvgIconLibraryBooks as ReactComponent };